// extracted by mini-css-extract-plugin
export default {"tiempo":"PopupTiempo_tiempo__PBp-m"};